
import React from "react";
import FounderSection from "./FounderSection";

import aboutimg from "../images/aboutbanner.png";
import barabout from "../images/bar-about.jpeg";
import founderPhoto1 from "../images/about1.png";
import founderPhoto2 from "../images/about3.png";

const AboutUs = () => {
  const stats = [
    { number: "15+", title: "Years Experience" },
    { number: "500+", title: "Furniture Designs" },
    { number: "100+", title: "Business Partners" },
    { number: "25+", title: "Countries Served" },
  ];

  const features = [
    {
      title: "Premium Craftsmanship",
      desc: "Every product is carefully crafted with attention to detail and long-lasting durability.",
    },
    {
      title: "Sustainable Manufacturing",
      desc: "We follow environmentally conscious processes and responsible sourcing.",
    },
    {
      title: "Modern Design",
      desc: "Contemporary furniture solutions designed for modern lifestyles.",
    },
    {
      title: "Global Standards",
      desc: "Products built to meet international quality and export requirements.",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "Poppins, sans-serif",
        background: "#fff",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        margin: 0,
        padding: 0,
      }}
    >
      {/* HERO SECTION */}
      <section
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${aboutimg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          color: "#fff",
          padding: "60px 8%",
          boxSizing: "border-box",
        }}
      >
        <div style={{ maxWidth: "850px" }}>
          <span
            style={{
              color: "#d4af37",
              letterSpacing: "4px",
              fontWeight: "600",
            }}
          >
            ABOUT INTRADING
          </span>

          <h1
            style={{
              fontSize: "clamp(38px, 5.5vw, 72px)",
              lineHeight: "1.1",
              margin: "25px 0",
            }}
          >
            Crafting Premium
            <br />
            Furniture For
            <br />
            Modern Living
          </h1>

          <p
            style={{
              fontSize: "clamp(16px, 1.5vw, 20px)",
              lineHeight: "1.8",
              maxWidth: "700px",
            }}
          >
            Combining innovation, craftsmanship and sustainable
            manufacturing to create furniture that enhances spaces
            and inspires modern lifestyles.
          </p>
        </div>
      </section>

      {/* FOUNDER SECTION */}
      <FounderSection />

      {/* FIRST FULL-WIDTH IMAGE */}
      <section
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          overflow: "hidden",
          lineHeight: 0,
          background: "#fff",
        }}
      >
        <img
          src={founderPhoto1}
          alt="Intrading Founder"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            maxWidth: "100%",
            objectFit: "contain",
            objectPosition: "center",
            margin: 0,
            padding: 0,
            border: 0,
          }}
        />
      </section>

      {/* SECOND FULL-WIDTH IMAGE */}
      <section
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          overflow: "hidden",
          lineHeight: 0,
          background: "#fff",
        }}
      >
        <img
          src={founderPhoto2}
          alt="Intrading Founder and Team"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            maxWidth: "100%",
            objectFit: "contain",
            objectPosition: "center",
            margin: 0,
            padding: 0,
            border: 0,
          }}
        />
      </section>

      {/* OUR STORY */}
      <section className="about-story">
        <img
          src={barabout}
          alt="Intrading Furniture"
          className="about-story-image"
        />

        <div>
          <span
            style={{
              color: "#d4af37",
              fontWeight: "600",
              letterSpacing: "2px",
            }}
          >
            OUR STORY
          </span>

          <h2
            style={{
              fontSize: "clamp(32px, 4vw, 52px)",
              lineHeight: "1.2",
              margin: "20px 0",
              color: "#111",
            }}
          >
            Excellence Built
            <br />
            Through Experience
          </h2>

          <p className="about-story-text">
            Intrading is a trusted furniture manufacturing and
            sourcing company dedicated to delivering premium
            quality products with exceptional craftsmanship.
          </p>

          <p className="about-story-text">
            Our commitment to quality, innovation and customer
            satisfaction has enabled us to build long-term
            relationships with clients across domestic and
            international markets.
          </p>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="about-stats">
        {stats.map((item, i) => (
          <div key={i}>
            <h2 className="about-stat-number">{item.number}</h2>

            <p className="about-stat-title">{item.title}</p>
          </div>
        ))}
      </section>

      {/* FEATURES SECTION */}
      <section className="about-features">
        <h2 className="about-features-heading">Why Choose Us</h2>

        <div className="about-features-grid">
          {features.map((item, i) => (
            <div className="about-feature-card" key={i}>
              <h3>{item.title}</h3>

              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="about-cta">
        <h2>Ready To Work With Us?</h2>

        <p>
          Discover premium furniture solutions designed to elevate
          your spaces with style, comfort and durability.
        </p>

        <button
          onClick={() => {
            window.location.href = "/contact";
          }}
        >
          Contact Us
        </button>
      </section>

      {/* RESPONSIVE CSS */}
      <style>{`
        .about-story {
          padding: 120px 8%;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 70px;
          align-items: center;
          box-sizing: border-box;
          width: 100%;
        }

        .about-story-image {
          display: block;
          width: 100%;
          max-width: 100%;
          height: 600px;
          object-fit: contain;
          border-radius: 20px;
        }

        .about-story-text {
          color: #555;
          line-height: 2;
          margin-bottom: 20px;
        }

        .about-stats {
          background: #1b140b;
          padding: 90px 8%;
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 30px;
          text-align: center;
          box-sizing: border-box;
        }

        .about-stat-number {
          color: #d4af37;
          font-size: clamp(36px, 4vw, 60px);
          margin: 0 0 10px;
        }

        .about-stat-title {
          color: #fff;
          font-size: 18px;
          line-height: 1.6;
          margin: 0;
        }

        .about-features {
          padding: 120px 8%;
          background: #f8f8f8;
          box-sizing: border-box;
        }

        .about-features-heading {
          text-align: center;
          font-size: clamp(34px, 4vw, 55px);
          margin: 0 0 70px;
          color: #111;
        }

        .about-features-grid {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          gap: 30px;
        }

        .about-feature-card {
          background: #fff;
          padding: 35px;
          border-radius: 18px;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
          box-sizing: border-box;
          min-width: 0;
        }

        .about-feature-card h3 {
          margin: 0 0 15px;
          color: #111;
          line-height: 1.5;
        }

        .about-feature-card p {
          color: #666;
          line-height: 1.8;
          margin: 0;
        }

        .about-cta {
          background: #d4af37;
          padding: 100px 8%;
          text-align: center;
          box-sizing: border-box;
        }

        .about-cta h2 {
          font-size: clamp(32px, 4vw, 55px);
          line-height: 1.2;
          color: #111;
          margin: 0 0 20px;
        }

        .about-cta p {
          max-width: 800px;
          margin: 0 auto 30px;
          line-height: 1.8;
          color: #222;
        }

        .about-cta button {
          background: #111;
          color: #fff;
          border: none;
          padding: 16px 40px;
          border-radius: 50px;
          font-size: 16px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .about-cta button:hover {
          background: #333;
        }

        @media (max-width: 992px) {
          .about-story {
            gap: 35px;
            padding: 80px 5%;
          }

          .about-story-image {
            height: 450px;
          }

          .about-features-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .about-stats {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .about-features {
            padding: 80px 5%;
          }
        }

        @media (max-width: 600px) {
          .about-story {
            grid-template-columns: 1fr;
            gap: 35px;
            padding: 60px 6%;
          }

          .about-story-image {
            height: auto;
          }

          .about-stats {
            padding: 60px 5%;
            gap: 35px 15px;
          }

          .about-stat-title {
            font-size: 15px;
          }

          .about-features {
            padding: 60px 6%;
          }

          .about-features-heading {
            margin-bottom: 40px;
          }

          .about-features-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .about-feature-card {
            padding: 28px;
          }

          .about-cta {
            padding: 65px 6%;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;
